import script from "./indicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./indicator.vue?vue&type=script&lang=ts&setup=true"

import "./indicator.vue?vue&type=style&index=0&id=0ad93379&lang=css"

const __exports__ = script;

export default __exports__